import { ResponsiveLine } from "@nivo/line";
import { useState, useEffect } from "react";
import { useTheme, useMediaQuery, Box } from "@mui/material";
import { tokens } from "../theme";

const LineChart = ({ data, minValue, maxValue, manualTicks }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery("(max-width:600px)");
  const [currentTime, setCurrentTime] = useState("");

  useEffect(() => {
    const updateClock = () => {
      const now = new Date();
      setCurrentTime(
        now.toLocaleTimeString("en-US", {
          timeZone: "Asia/Kuwait",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        }),
      );
    };
    updateClock();
    const interval = setInterval(updateClock, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          "& svg path": {
            filter: "drop-shadow(0px 4px 8px rgba(255, 215, 0, 0.25))",
          },
        }}
      >
        <ResponsiveLine
          data={data}
          theme={{
            axis: {
              ticks: {
                text: {
                  fill: colors.grey[300],
                  fontSize: isMobile ? 9 : 11,
                  fontWeight: 500,
                  fontFamily: "Inter, sans-serif",
                },
              },
            },
            grid: {
              line: {
                stroke: "rgba(255, 255, 255, 0.05)",
                strokeWidth: 1,
                strokeDasharray: "4 4",
              },
            },
            crosshair: {
              line: {
                stroke: "#FFD700",
                strokeWidth: 1.5,
                strokeOpacity: 0.4,
              },
            },
            tooltip: {
              container: {
                background: "#1F2A40",
                color: "#FFF",
                fontSize: 12,
                borderRadius: 8,
                boxShadow: "0 4px 15px rgba(0,0,0,0.5)",
                border: "1px solid rgba(255, 215, 0, 0.3)",
                padding: "8px 12px",
              },
            },
          }}
          // تكبير الهامش السفلي (bottom: 60) والأيسر (left: 70) لإعطاء مساحة تامة للأرقام والوقت والظهور بدون قص
          margin={{ top: 20, right: 35, bottom: 60, left: 70 }}
          xScale={{ type: "point" }}
          yScale={{
            type: "linear",
            min: minValue,
            max: maxValue,
            stacked: false,
            nice: false, // لضمان الالتزام المطلق بالـ manualTicks المحسوبة بدقة
          }}
          axisBottom={{
            orient: "bottom",
            tickSize: 0,
            tickPadding: 15,
            tickRotation: isMobile ? -30 : 0,
          }}
          axisLeft={{
            orient: "left",
            tickSize: 0,
            tickPadding: 15,
            tickValues: manualTicks,
            format: (v) => Number(v).toFixed(3),
          }}
          enablePoints={true}
          pointSize={6}
          pointColor="#1F2A40"
          pointBorderWidth={2}
          pointBorderColor="#FFD700"
          colors={["#FFD700"]}
          lineWidth={3}
          curve="monotoneX"
          enableArea={true}
          defs={[
            {
              id: "gradientA",
              type: "linearGradient",
              colors: [
                { offset: 0, color: "#FFD700", opacity: 0.15 },
                { offset: 1, color: "#FFD700", opacity: 0.0 },
              ],
            },
          ]}
          fill={[{ match: "*", id: "gradientA" }]}
          useMesh={true}
          animate={true}
        />
      </Box>

      {/* الساعة السفلية الرقمية */}
      <Box
        sx={{
          textAlign: "center",
          color: "#FFD700",
          fontWeight: "800",
          fontSize: isMobile ? "1.5rem" : "2.4rem",
          paddingBottom: "5px",
          marginTop: "5px",
          fontFamily: "'Share Tech Mono', 'Courier New', monospace",
          textShadow: "0px 0px 15px rgba(255, 215, 0, 0.5)",
          letterSpacing: "1px",
        }}
      >
        {currentTime}
      </Box>
    </Box>
  );
};

export default LineChart;
